<section class="precios" id="precios">
  <div class="precios__container">
    <!-- Cabecera -->
    <header class="precios__header" appReveal>
      <p class="precios__label">Precios</p>
      <h1 class="precios__title">
        Un precio base con lo esencial.<br />
        Añade solo lo que necesites.
      </h1>
      <p class="precios__intro">
        Empieza con el pack base —el fichaje de tu equipo, la facturación, tus
        clientes y tus gastos— y suma los módulos que tu negocio use. Ficha
        quien haga falta: solo pagas por quien gestiona. Todo en un único pago
        mensual, sin permanencia.
      </p>
      <p class="precios__annual-note">
        <i class="ph ph-gift"></i> Paga anual y llévate
        <strong>dos meses sin coste</strong>
      </p>
      <p class="precios__tax-note">Precios mensuales sin IVA.</p>
    </header>

    <!-- Pack base -->
    <div class="precios__base" appReveal>
      <article class="precios__plan precios__plan--featured">
        <span class="precios__plan-badge">Pack base</span>
        <h3 class="precios__plan-name">{{ base.name }}</h3>
        <p class="precios__plan-modules">{{ base.tagline }}</p>
        <p class="precios__plan-price">
          <span class="precios__plan-amount">{{ base.price }} €</span>
          <span class="precios__plan-period">/mes</span>
        </p>
        <p class="precios__plan-annual">
          o {{ base.annual }} €/año (dos meses sin coste)
        </p>
        <ul class="precios__plan-features">
          @for (f of base.features; track f) {
            <li>
              <i class="ph ph-check"></i><span>{{ f }}</span>
            </li>
          }
        </ul>
        <p-button
          label="Configura tu prueba"
          routerLink="/prueba-sin-compromiso"
          styleClass="w-full"
          size="large" />
      </article>
    </div>

    <!-- Ancla de precio: coste medio oficial de un fichaje digital legal -->
    <p class="precios__callout precios__callout--spaced" appReveal>
      El Consejo de Estado cifra en <strong>55,40 €/mes</strong> el coste medio
      de adoptar un fichaje digital legal. El pack base cuesta menos e incluye
      también la facturación, tus clientes y tus gastos.
    </p>

    <!-- Módulos à la carte (desde el CMS) -->
    <div class="precios__block" appReveal>
      <h2 class="precios__block-title">Añade módulos a tu medida</h2>
      <p class="precios__block-intro">
        Cada módulo funciona por sí solo. Los complementos mejoran un módulo
        concreto y van con él. Todo se cobra en el mismo pago mensual, sin altas
        sueltas.
      </p>

      @if (isLoading()) {
        <p class="precios__block-intro">Cargando catálogo…</p>
      } @else {
        <div class="precios__packs">
          @for (m of modulos(); track m.name) {
            <article class="precios__pack">
              <span class="precios__pack-dot" [style.background]="m.color"></span>
              <h4 class="precios__pack-name">{{ m.name }}</h4>
              <p class="precios__pack-price">
                <span>+{{ m.price }} €</span><small>/mes</small>
              </p>
              @if (m.desc) {
                <p class="precios__pack-includes">{{ m.desc }}</p>
              }
            </article>
          }
        </div>
      }
    </div>

    <!-- Complementos (desde el CMS) -->
    @if (complementos().length > 0) {
      <div class="precios__block" appReveal>
        <h2 class="precios__block-title">Complementos</h2>
        <p class="precios__block-intro">
          Potencian un módulo que ya tienes. No existen sin él. Los de
          <strong>IA</strong> incluyen una bolsa de escaneos al mes.
        </p>
        <div class="precios__packs">
          @for (c of complementos(); track c.name) {
            <article class="precios__pack">
              <span class="precios__pack-dot" [style.background]="c.color"></span>
              <h4 class="precios__pack-name">{{ c.name }}</h4>
              <p class="precios__pack-price">
                <span>+{{ c.price }} €</span><small>/mes</small>
              </p>
              @if (c.capacity) {
                <p class="precios__pack-capacity">{{ c.capacity }}</p>
              }
              @if (c.desc) {
                <p class="precios__pack-includes">{{ c.desc }}</p>
              }
            </article>
          }
        </div>
      </div>
    }

    <!-- Tipos de usuario -->
    <div class="precios__block" appReveal>
      <h2 class="precios__block-title">Usuarios: ficha todo tu equipo</h2>
      <p class="precios__block-intro">
        No cobramos licencia por el trabajador que solo ficha. Tienes dos tipos
        de usuario:
      </p>
      <div class="precios__users">
        @for (u of usuarios; track u.tipo) {
          <div class="precios__user-card">
            <div class="precios__user-head">
              <h4>{{ u.tipo }}</h4>
              <span class="precios__user-price">{{ u.price }}</span>
            </div>
            <p>{{ u.desc }}</p>
          </div>
        }
      </div>
      <p class="precios__callout">
        Los operativos son <strong>ilimitados</strong>: da igual que fichen 5 o
        40 personas, el precio no cambia. La diferencia está en los permisos:
        facturar, ver el global y sacar informes pide usuario completo.
      </p>
    </div>

    <!-- Packs verticales (desde el CMS) -->
    @if (packs().length > 0) {
      <div class="precios__block" appReveal>
        <h2 class="precios__block-title">Packs por sector</h2>
        <p class="precios__block-intro">
          El pack base con los módulos de tu sector ya configurados. Son los
          mismos módulos a los mismos precios: el pack solo te ahorra elegir.
        </p>
        <div class="precios__packs">
          @for (pack of packs(); track pack.name) {
            <article class="precios__pack">
              <span class="precios__pack-dot" [style.background]="pack.color"></span>
              <h4 class="precios__pack-name">{{ pack.name }}</h4>
              <p class="precios__pack-price">
                <small>desde </small><span>{{ pack.price }} €</span><small>/mes</small>
              </p>
              @if (pack.desc) {
                <p class="precios__pack-includes">{{ pack.desc }}</p>
              }
            </article>
          }
        </div>
      </div>
    }

    <!-- Puesta en marcha (servicio opcional, pago único) -->
    <div class="precios__block" appReveal>
      <h2 class="precios__block-title">Puesta en marcha</h2>
      <p class="precios__block-intro">
        Opcional: si quieres que te lo dejemos montado, lo hacemos por ti. Un
        servicio de pago único con alcance cerrado.
      </p>
      <div class="precios__setup">
        <ul class="precios__setup-list">
          <li>
            <i class="ph ph-check"></i>
            Configuración inicial de tu cuenta: empresa, usuarios y módulos
            elegidos.
          </li>
          <li>
            <i class="ph ph-check"></i>
            Importación de tu Excel de clientes y empleados.
          </li>
          <li>
            <i class="ph ph-check"></i>
            Sesión de formación con tu equipo para empezar a trabajar.
          </li>
        </ul>
        <p class="precios__setup-price">
          <span class="precios__setup-amount">150 €</span>
          <small>pago único</small>
        </p>
      </div>
      <p class="precios__setup-consult">
        ¿Necesitas más ayuda después? Sesiones de consultoría de 1 hora ·
        <strong>60 €</strong>.
      </p>
    </div>

    <!-- A medida -->
    <div class="precios__custom" appReveal>
      <div class="precios__custom-text">
        <h2>¿Necesitas algo a tu medida?</h2>
        <p>
          Lo desarrollamos sobre la misma plataforma y te acompañamos con
          consultores que conocen tu negocio. Es lo que nos diferencia: llegamos
          donde el software genérico no acaba de encajar.
        </p>
      </div>
      <p-button label="Cuéntanos tu caso" routerLink="/contacto" size="large" />
    </div>

    <!-- FAQ -->
    <div class="precios__block" appReveal>
      <h2 class="precios__block-title">Preguntas frecuentes</h2>
      <div class="precios__faqs">
        @for (faq of faqs; track faq.q; let i = $index) {
          <div
            class="precios__faq"
            [class.precios__faq--open]="activeFaq === i">
            <button type="button" class="precios__faq-q" (click)="toggleFaq(i)">
              <span>{{ faq.q }}</span>
              <i class="ph ph-caret-down"></i>
            </button>
            @if (activeFaq === i) {
              <p class="precios__faq-a">{{ faq.a }}</p>
            }
          </div>
        }
      </div>
    </div>

    <!-- CTA final -->
    <div class="precios__cta" appReveal>
      <h2>Empieza hoy. Crece al ritmo de tu negocio.</h2>
      <p>
        Prueba TodoSector 14 días sin compromiso. Sin tarjeta, sin permanencia.
      </p>
      <div class="precios__cta-buttons">
        <p-button
          label="Configura tu prueba"
          routerLink="/prueba-sin-compromiso"
          size="large" />
        <p-button
          label="Hablar con nosotros"
          routerLink="/contacto"
          [outlined]="true"
          size="large" />
      </div>
    </div>
  </div>
</section>
